// @mui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
// hooks
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';
// theme
import { bgBlur } from 'src/theme/css';
// components
import MainLogo from 'src/components/logo/mainlogo';
//
// import { Button } from '@mui/material';
// import { RouterLink } from 'src/routes/components';
// import { paths } from 'src/routes/paths';
import { Button, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
import { startSales } from 'src/constants';
import { HEADER } from '../config-layout';
import { navConfig } from './config-navigation';
import NavMobile from './nav/mobile';
import NavDesktop from './nav/desktop';
//
import { ModeButton, HeaderShadow, LanguagePopover, CardButton } from '../_common';

// ----------------------------------------------------------------------

export default function Header() {
  const theme = useTheme();

  const mdUp = useResponsive('up', 'md');
  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);
  const { isRTL } = useLocales();

  // const orderTracking = paths.order.root;
  // const orderTracking = '/';

  return (
    <AppBar>
      <Toolbar
        disableGutters
        sx={{
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Container maxWidth="xl" sx={{ height: 1, display: 'flex', alignItems: 'center' }}>
          <MainLogo />
          <Box sx={{ mr: { xs: 0, md: 5 } }} />
          {mdUp && <NavDesktop offsetTop={offsetTop} data={navConfig} />}
          <Box sx={{ flexGrow: 1 }} />
          <Stack alignItems="center" direction={{ xs: 'row', md: 'row-reverse' }}>
            {/* {mdUp && (
              <Button component={RouterLink} href={orderTracking} variant="outlined" sx={{ mx: 1 }}>
                Tracking
              </Button>
            )} */}

            {startSales && <CardButton />}
            <Box sx={{ mx: 1 }}>
              <LanguagePopover />
            </Box>
            {mdUp && (
              <ModeButton
                sx={{
                  ml: { xs: 1, md: 0 },
                  mr: { md: 2 },
                }}
              />
            )}
            {startSales && (
              <>
                {mdUp && (
                  <Button
                    component={RouterLink}
                    href={paths.product.root}
                    size="medium"
                    variant="contained"
                    sx={{
                      px: { xs: 1, md: 3 },
                      py: { xs: 1, md: 1 },
                      mx: { xs: 0, md: 2 },
                      ml: 1,
                      minWidth: { xs: 'auto', md: 'auto' },
                      fontWeight: 'bold',
                      background: 'linear-gradient(90deg, #BD2031, #3B8E42)',
                      border: 0,
                      borderRadius: { xs: '50%', md: 5 },
                      boxShadow: '0 6px 20px rgba(187, 31, 45, 0.4)',
                      '&:hover': {
                        boxShadow: '0 8px 25px rgba(187, 31, 45, 0.6)',
                        transform: 'translateY(-2px)',
                      },
                      transition: 'all 0.3s ease',
                    }}
                    startIcon={
                      mdUp ? <Iconify icon="solar:bag-smile-bold" width={22} /> : undefined
                    }
                  >
                    {mdUp ? (
                      <Typography
                        variant="button"
                        sx={{ color: 'white', fontWeight: 'bold', mb: -0.5 }}
                      >
                        {isRTL ? 'أطلب الآن' : 'Order Now'}
                      </Typography>
                    ) : (
                      <Iconify icon="solar:bag-smile-bold" width={24} />
                    )}
                  </Button>
                )}
                <Button
                  component={RouterLink}
                  href={paths.subscription.root}
                  size="medium"
                  variant="contained"
                  sx={{
                    px: { xs: 1.5, md: 3 },
                    py: { xs: 0.7, md: 1 },
                    mx: 0,
                    minWidth: { xs: 'auto', md: 'auto' },
                    fontWeight: 'bold',
                    background: 'linear-gradient(90deg, #3B8E42, #2E7D32)',
                    border: 0,
                    borderRadius: { xs: 2, md: 3 },
                    boxShadow: '0 6px 20px rgba(59, 142, 66, 0.4)',
                    '&:hover': {
                      boxShadow: '0 8px 25px rgba(59, 142, 66, 0.6)',
                      transform: 'translateY(-2px)',
                    },
                    transition: 'all 0.3s ease',
                  }}
                  startIcon={<Iconify icon="solar:calendar-mark-bold" width={mdUp ? 22 : 20} />}
                >
                  <Typography
                    variant={mdUp ? 'button' : 'body2'}
                    sx={{ color: 'white', fontWeight: 'bold', mb: -0.5 }}
                  >
                    {isRTL ? 'اشترك' : 'Subscribe'}
                  </Typography>
                </Button>
              </>
            )}
            {!mdUp && <NavMobile offsetTop={offsetTop} data={navConfig} />}
          </Stack>
        </Container>
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
